// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"88f57d08","45":"68a726e8","787":"5b557567","851":"4badc9ee","867":"d7f45136"}[chunkId] + ".chunk.js";
};